import { render, staticRenderFns } from "./ClassMelontv.vue?vue&type=template&id=fab996f6&"
import script from "./ClassMelontv.vue?vue&type=script&lang=js&"
export * from "./ClassMelontv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports